import * as React from 'react';
// tslint:disable-next-line:no-duplicate-imports
import { useState } from 'react';
import { match } from 'react-router';
import { OrderDetail } from '../../store';
import { getTrackingUrl } from '../../store/shipment';
import { OrderActions } from '../orderList/orderList';

export interface OrderAttributes {
    order: OrderDetail;
}

export interface OrderActions {
    fetch(id: number, done: () => void);
}

export type OrderProps = OrderAttributes & OrderActions & {
    match: match<{orderId: string}>;
};

enum OrderState {
    loading,
    loaded
}

export const OrderTrack = (props: OrderProps) => {
    const [state, setState] = useState<OrderState>(OrderState.loading);
    const { order, fetch, match: {params: {orderId} }} = props;

    React.useEffect(() => {
        if (state === OrderState.loading) {
            fetch(parseInt(orderId, 10), () => {
                setState(OrderState.loaded);
            });
        }
    });

    if (state === OrderState.loading) {
        return <div>Loading...</div>;
    }

    window.location.href = getTrackingUrl(order);
};
